<script setup>
import { getDefaultOptions } from '@/pages/kvartalsrapport/charts/chartUtils.js';
import { useKvartalsrapportStore } from '@/stores/kvartalsrapportStore.js';
import dayjs from 'dayjs';
import { formatNumber } from '@/pages/kvartalsrapport/kvartalsrapportUtil';

const props = defineProps({
  print: {
    type: Boolean,
    default: false,
  },
  lts: {
    type: Boolean,
    default: false,
  },
});

const store = useKvartalsrapportStore();

function getOptions() {
  return Object.assign({}, getDefaultOptions(props.print), {
    dataLabels: {
      enabled: false,
      formatter: function (value) {
        return formatNumber(value);
      },
    },
    colors: ['#e49d3b', '#6bb8bc'],
  });
}

function getSeries() {
  const bestandTotaler = store.udvikling.bestandTotaler;
  const detteAar = bestandTotaler.slice(-12);
  const forrigeAar = bestandTotaler.slice(-24).slice(0, 12);

  const series = [
    {
      name: 'Forrige år',
      data: forrigeAar.map((x) => {
        if (props.lts) {
          return {
            x: `${dayjs(x.bestandDato).add(-1, 'day').format('MMM')}`,
            y: x.sumOpsparetVaerdiLts / 1000000,
          };
        } else {
          return {
            x: `${dayjs(x.bestandDato).add(-1, 'day').format('MMM')}`,
            y: x.sumOpsparetVaerdiLivrente / 1000000,
          };
        }
      }),
    },
    {
      name: 'Dette år',
      data: detteAar.map((x) => {
        if (props.lts) {
          return {
            x: `${dayjs(x.bestandDato).add(-1, 'day').format('MMM')}`,
            y: x.sumOpsparetVaerdiLts / 1000000,
          };
        } else {
          return {
            x: `${dayjs(x.bestandDato).add(-1, 'day').format('MMM')}`,
            y: x.sumOpsparetVaerdiLivrente / 1000000,
          };
        }
      }),
    },
  ];

  return series;
}
</script>

<template>
  <div class="chart" v-if="store.udvikling.bestandTotaler">
    <apexchart height="100%" type="bar" :options="getOptions()" :series="getSeries()"></apexchart>
  </div>
</template>

<style scoped lang="scss">
.chart {
  height: 200px;
}
</style>
